
import { all } from 'redux-saga/effects';

import {
    watchCategoryAddSet,
    watchCategoryCreate,
    watchCategoryCreateItem,
    watchCategoryDelete,
    watchCategoryDeleteItem,
    watchCategoryEditItem,
    watchCategoryGenerateClusters,
    watchCategoryGet,
    watchCategoryImportData,
    watchCategoryRemove,
    watchCategorySet
} from './category';
import {
    watchExportDataClustersCsv,
    watchExportDataClustersGeoJson,
    watchExportDataParcCsv,
    watchExportDataParcGeoJson,
    watchExportDataParcCategoryJson
} from './exportData';
import { watchChangeView, watchChangeLayerVisibility } from './map';
import { watchGetObjectFromMap } from './info';
import { watchGetObjectOpsub } from './info';
import { watchGetObjectParcela } from './info';
import { watchGetObjectTeleso } from './info';
import {
    watchKnDataGet
} from './knData';
import { watchGetProject } from './project';
import { watchGetProjectList } from './projectList';
import {
    watchListAdd,
    watchListGet,
    watchListRemove
} from './list';
import {
    watchSearchGetParams,
    watchSearchRunSearch,
    watchSearchOpen
} from './search';
import {
    watchSelectionAdd,
    watchSelectionClear,
    watchSelectionFilter,
    watchSelectionGet,
    watchSelectionRemove,
    watchSelectionReplace
} from './selection';

/*
import { watchGetParams } from './app';
*/
import serverApi from '../common/client/serverApi';
import { authFlow } from '../common/client/sagas/auth';
import { keepConnectionWorkFlow } from '../common/client/sagas/keepConnection';

import history from '../history';

export default function* rootSagas() {
    const options = {
        history: history,
        serverApi: serverApi
    };

    yield all([
        /*
        watchGetParams(),
        */

        watchCategoryAddSet(options),
        watchCategoryCreate(options),
        watchCategoryCreateItem(options),
        watchCategoryDelete(options),
        watchCategoryDeleteItem(options),
        watchCategoryEditItem(options),
        watchCategoryGenerateClusters(options),
        watchCategoryGet(options),
        watchCategoryImportData(options),
        watchCategoryRemove(options),
        watchCategorySet(options),
        watchChangeLayerVisibility(options),
        watchChangeView(options),
        watchExportDataClustersCsv(options),
        watchExportDataClustersGeoJson(options),
        watchExportDataParcCsv(options),
        watchExportDataParcGeoJson(options),
        watchExportDataParcCategoryJson(options),
        watchGetObjectFromMap(options),
        watchGetObjectOpsub(options),
        watchGetObjectParcela(options),
        watchGetObjectTeleso(options),
        watchGetProject(options),
        watchGetProjectList(options),
        watchGetProjectList(options),
        watchKnDataGet(options),
        watchListAdd(options),
        watchListGet(options),
        watchListRemove(options),
        watchSearchGetParams(options),
        watchSearchOpen(options),
        watchSearchRunSearch(options),
        watchSelectionAdd(options),
        watchSelectionClear(options),
        watchSelectionFilter(options),
        watchSelectionGet(options),
        watchSelectionRemove(options),
        watchSelectionReplace(options),
        keepConnectionWorkFlow(options),
        authFlow({
            ...options,
            afterLogoutUrl: '/'
        })
    ]);
}
